import React, { useState } from "react";
import {
  Birthday,
  Coorperate,
  Event,
  Myself,
  Object as Img_Object,
  Other,
  Pet,
  SomeoneElse,
  WeddingDate,
} from "../../assets";
import { toast } from "react-toastify";
import CustomToggler from "../CustomToggler";
import { Modal, ModalBody, Button, Form, Row, Col, Spinner } from "reactstrap";
import { createMemoir } from "../../redux/actions/memoir.action";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { customAlert } from "../../redux/actions/alertActions";
import CustomDatePicker from "../CustomDatePicker";
import { useHistory } from "react-router-dom";

function CreateMemora(props) {
  const [categories, setCategories] = useState([
    { name: "Myself", image: Myself },
    { name: "Someone else", image: SomeoneElse },
    { name: "Pet", image: Pet },
    { name: "Birthday", image: Birthday },
    { name: "Anniversary", image: WeddingDate },
    { name: "Event", image: Event },
    { name: "Coorperate", image: Coorperate },
    { name: "Object", image: Img_Object },
    { name: "Other", image: Other },
  ]);
  const [deathOpen, setDeathOpen] = useState(false);
  console.log(deathOpen,'deathOpen')
  const { uid } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.memoir);
  const dispatch = useDispatch();
  const history = useHistory();
  const resetMemoirState = () => {
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    Array.from(document.querySelectorAll("textarea")).forEach(
      (textarea) => (textarea.value = "")
    );

    if (props.profileType == "else") {
      props.setMemoirData({
        memoir_title: "",
        title: "",
        first_name: "",
        last_name: "",
        introduction: "",
        relationship: "",
        date_of_birth: "",
        date_of_death: "",
        home_town: "",
        isMemoirPublic: props.memoirData.isMemoirPublic,
        isHomeTownPublic: props.memoirData.isHomeTownPublic,
        isDOBPublic: props.memoirData.isDOBPublic,
        isHideFromSearchEngines: props.memoirData.isHideFromSearchEngines,
        isIntroductionVisible: props.memoirData.isIntroductionVisible,
      });
    } else {
      props.setMemoirData({
        else_category: "",
        end_date: "",
        introduction: "",
        location: "",
        memoir_title: "",
        start_date: "",
        isMemoirPublic: props.memoirData.isMemoirPublic,
        isHomeTownPublic: props.memoirData.isHomeTownPublic,
        isDOBPublic: props.memoirData.isDOBPublic,
        isHideFromSearchEngines: props.memoirData.isHideFromSearchEngines,
        isIntroductionVisible: props.memoirData.isIntroductionVisible,
      });
    }
  };
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const handleMemoirFieldChange = (name, value) => {
    let memoData = props.memoirData;
    memoData[name] = value;
    props.setMemoirData(memoData);
    forceUpdate();
  };
  const toggleDeath = () => {
    setDeathOpen(!deathOpen);
  };

  return (
    <>
      <Modal
        isOpen={props.isOpen.category}
        size="xl"
        centered
        className="custom-modal"
      >
        <ModalBody>
          <div className="d-flex">
            <div
              className="ml-auto pointer"
              onClick={() => props.toggleModal("category")}
            >
              <i className="fa fa-times"></i>
            </div>
          </div>
          <div className="modal-content-wrapper pt-0">
            <h4 className="text-center mt-3 font-weight-bold">
              Choose from the categories Below
            </h4>
            <Row className="justify-content-center">
              <Col md="10" xl="8">
                <div className="row">
                  {categories.map((category, idx) => (
                    <div className="col-md-6 col-lg-4 col-xl-4 mt-5 text-center">
                      <div
                        className={`category-card ${
                          props.selectedCat == category.name ? "active" : ""
                        }`}
                        onClick={(e) => props.setSelectedCat(category.name)}
                      >
                        <div className="card-body text-center d-flex flex-column">
                          <img
                            src={category.image}
                            style={{
                              height: 70,
                              margin: "0 auto",
                            }}
                          />
                          <span className="mt-3">{category.name}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
            <button
              className="btn btn-outline d-block mx-auto mt-3 position-relative dashboard-btn"
              style={{ fontSize: 32, minHeight: 60 }}
              onClick={(e) => {
                e.preventDefault();
                if (props.selectedCat != "") {
                  if (
                    props.selectedCat == "Myself" ||
                    props.selectedCat == "Someone else"
                  ) {
                    props.setProfileType("person");
                  } else {
                    props.setProfileType("else");
                  }
                  props.toggleModal("createTimeline");
                }
              }}
            >
              Creating a Memoir
            </button>
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={props.isOpen.createTimeline}
        size="lg"
        centered
        className="custom-modal"
        toggle={() => {
          props.toggleModal("createTimeline");
        }}
      >
        <ModalBody>
          <div className="d-flex">
            <div
              className="ml-auto pointer"
              onClick={(e) => {
                handleMemoirFieldChange("date_of_birth", "");
                props.toggleModal("createTimeline");
              }}
            >
              <i className="fa fa-times"></i>
            </div>
          </div>
          <Form
            onSubmit={async (e) => {
              e.preventDefault();
              let obj = { ...props.memoirData };
              // if (props.profileType == 'person') {
              // 	obj['category'] = props.selectedCat;
              // }

              obj["category"] = props.selectedCat;
              console.log("Data...", obj);

              if (props.profileType == "person") {
                if (
                  props.memoirData.memoir_title == "" ||
                  props.memoirData.title == "" ||
                  props.memoirData.first_name == "" ||
                  props.memoirData.last_name == "" ||
                  props.memoirData.introduction == "" ||
                  props.memoirData.home_town == ""
                  // ||
                  // props.memoirData.relationship == ''
                ) {
                  dispatch(customAlert(true, "Please fill all fields"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please fill all fields');
                } else {
                  if (uid) {
                    // console.log('obj', obj)
                    await dispatch(
                      createMemoir(obj, uid, (res) => {
                        console.log(res);
                        history.push(`/dashboard/${res}/timeline`);
                      })
                    );
                    resetMemoirState();
                    props.toggleModal("createTimeline");
                  } else {
                    dispatch(customAlert(true, "Undefined user id!"));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 1500);
                    // toast.warning('Undefined user id!');
                  }
                }
              } else {
                if (
                  props.memoirData.memoir_title == "" ||
                  props.memoirData.introduction == ""
                  // ||
                  // props.memoirData.home_town == ''
                ) {
                  dispatch(customAlert(true, "Please fill all fields"));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                  // toast.warning('Please fill all fields');
                } else if (props.memoirData.category == "") {
                  dispatch(customAlert(true, "Please Choose Category "));
                  setTimeout(() => {
                    dispatch(customAlert(false, ""));
                  }, 1500);
                } else {
                  if (uid) {
                    await dispatch(
                      createMemoir(obj, uid, (res) => {
                        console.log(res);
                        history.push(`/dashboard/${res}/timeline`);
                      })
                    );
                    resetMemoirState();
                    props.toggleModal("createTimeline");
                  } else {
                    dispatch(customAlert(true, "Undefined user id!"));
                    setTimeout(() => {
                      dispatch(customAlert(false, ""));
                    }, 1500);
                    // toast.warning('Undefined user id!');
                  }
                }
              }
            }}
          >
            <div className="modal-content-wrapper pt-0">
              <h5 className="mt-3 font-weight-bold text-center">
                Create a Memoir
              </h5>
              <span className="d-block timeline-for mt-4">
                <h6>What is the Memoir for?</h6>
                <div className="d-flex radio-group">
                  <div className="d-flex radio align-items-center">
                    <input
                      type="radio"
                      name="profileType"
                      onClick={async (e) => {
                        await props.setProfileType("person");
                        props.setSelectedCat("person");
                        resetMemoirState();
                      }}
                      checked={props.profileType == "person"}
                      id="person"
                    />
                    <label className="ml-2 mt-2" for="person">
                      A Person
                    </label>
                  </div>
                  <div className="ml-5 d-flex radio align-items-center">
                    <input
                      type="radio"
                      name="profileType"
                      onClick={async (e) => {
                        await props.setProfileType("else");
                        props.setSelectedCat("else");
                        resetMemoirState();
                      }}
                      checked={props.profileType == "else"}
                      id="else"
                    />
                    <label className="ml-2 mt-2" for="else">
                      Something else
                    </label>
                  </div>
                </div>
              </span>
              <div
                className={`${
                  props.profileType == "person" ? "d-block" : "d-none"
                }`}
              >
                <div className="row mt-3">
                  <div className="col">
                    <label className="m-0">Memoir Title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Memoir Title"
                      required={props.profileType == "person"}
                      onChange={(e) =>
                        handleMemoirFieldChange("memoir_title", e.target.value)
                      }
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-2">
                    <label className="m-0">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Mr"
                      required={props.profileType == "person"}
                      // defaultValue={props.memoirData.title}
                      onChange={(e) =>
                        handleMemoirFieldChange("title", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-md-5">
                    <label className="m-0">First Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First name"
                      required={props.profileType == "person"}
                      // defaultValue={props.memoirData.first_name}
                      onChange={(e) =>
                        handleMemoirFieldChange("first_name", e.target.value)
                      }
                    />
                  </div>
                  <div className="col-md-5">
                    <label className="m-0">Last Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name"
                      required={props.profileType == "person"}
                      // defaultValue={props.memoirData.last_name}
                      onChange={(e) =>
                        handleMemoirFieldChange("last_name", e.target.value)
                      }
                    />
                  </div>
                </div>

                <label className="d-flex mt-3 m-0">Add an introduction</label>
                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="This Timeline was created to help collect our memories in a single place online"
                  // defaultValue={props.memoirData.introduction}
                  required={props.profileType == "person"}
                  onChange={(e) =>
                    handleMemoirFieldChange("introduction", e.target.value)
                  }
                />
                <h5 className="d-flex mt-5 mb-4">
                  What's your relationship to them?
                </h5>
                <select
                  className="form-control"
                  // required={props.profileType == 'person'}
                  // defaultValue={props.memoirData.relationship}
                  onChange={(e) =>
                    handleMemoirFieldChange("relationship", e.target.value)
                  }
                >
                  <option disabled selected>
                    Select (Optional)
                  </option>
                  <option value="parent">Parent</option>
                  <option value="child">Child</option>
                  <option value="spouse">Spouse</option>
                  <option value="sibling">Sibling</option>
                  <option value="friend">Friend</option>
                </select>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <label className="d-flex m-0">
                      Date of Birth (optional)
                    </label>
                    {/* <input
											type='date'
											// defaultValue={props.memoirData.date_of_birth}

											className='form-control'
										/> */}
                    <CustomDatePicker
                      id={"test"}
                      value={props.memoirData.date_of_birth}
                      max={moment().toISOString().substring(0, 10)}
                      onChange={(e) =>
                        handleMemoirFieldChange("date_of_birth", e.target.value)
                      }
                      isRequired={false}
                    />
                  </div>
                  <div className="col-md-6 ">
                    <label className="d-flex m-0">
                      Date of Death (optional)
                    </label>
                    <span
                      className={`${!deathOpen ? "d-block" : "d-none"} mt-3`}
                    >
                      - Present{" "}
                      <i
                        className="ml-2 fa fa-pencil pointer"
                        onClick={toggleDeath}
                      ></i>
                    </span>
                    <div>
                      
                    <span className={`${deathOpen ? "d-flex" : "d-none"}`}>
                      <CustomDatePicker
                      id={"test"}
                        // defaultValue={props.memoirData.date_of_birth}
                        max={moment().toISOString().substring(0, 10)}
                        onChange={(e) =>
                          handleMemoirFieldChange(
                            "date_of_death",
                            e.target.value
                          )
                        }
                        
                      />
                      <i
                        className="ml-2 fa fa-times text-danger pointer mt-3"
                        onClick={()=>toggleDeath()}
                      ></i>
                    </span>
                    </div>
                  </div>
                </div>
                <label className="d-flex mt-3 m-0">
                  What's their hometown?
                </label>
                <Row>
                  <Col md="8">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="City"
                      required={props.profileType == "person"}
                      // defaultValue={props.memoirData.home_town}
                      onChange={(e) =>
                        handleMemoirFieldChange("home_town", e.target.value)
                      }
                    ></input>
                  </Col>
                </Row>
              </div>
              <div
                className={`${
                  props.profileType == "else" ? "d-block" : "d-none"
                }`}
              >
                <div className="row mt-3">
                  <div className="col">
                    <label className="m-0">Memoir Title</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Memoir Title"
                      required={props.profileType == "else"}
                      // defaultValue={props.memoirData.title}
                      onChange={(e) =>
                        handleMemoirFieldChange("memoir_title", e.target.value)
                      }
                    />
                  </div>
                </div>
                <Row>
                  <Col md="8">
                    <label className="d-flex mt-3">Choose a Catrgory</label>
                    <select
                      className="form-control"
                      // defaultValue={props.memoirData.else_category}
                      required={props.profileType == "else"}
                      defaultValue={props.selectedCat}
                      onChange={(e) =>
                        handleMemoirFieldChange("else_category", e.target.value)
                      }
                    >
                      {categories.map((cat) => {
                        return <option value={cat.name}>{cat.name}</option>;
                      })}
                    </select>
                    {/* <label className="d-flex mt-3">Category selected</label>
                                        <input
                                            className="form-control"
                                            placeholder="Category selected"
                                        /> */}
                  </Col>
                </Row>
                <label className="d-flex mt-3">Add an introduction</label>
                <textarea
                  className="form-control"
                  required={props.profileType == "else"}
                  rows="4"
                  placeholder="This Timeline was created to help collect our memories in a single place online"
                  // defaultValue={props.memoirData.introduction}
                  onChange={(e) =>
                    handleMemoirFieldChange("introduction", e.target.value)
                  }
                />
                <div className="row mt-3">
                  <div className="col-md-8">
                    <label>Start date</label>
                    <CustomDatePicker
                      id={"test"}
                      value={props.memoirData.start_date}
                      max={moment().toISOString().substring(0, 10)}
                      onChange={(e) =>
                        handleMemoirFieldChange("start_date", e.target.value)
                      }
                      isRequired={props.profileType == "else"}
                    />
                    {/* <input
											type='date'
											className='form-control'
											placeholder='yyyy'
											required={
												props.profileType == 'else'
											}									
											onChange={e =>
												handleMemoirFieldChange(
													'start_date',
													e.target.value
												)
											}
										/> */}
                    {/* <div className="row">
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="yyyy"
                          // defaultValue={props.memoirData.start_date_yyyy}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'start_date_yyyy',
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="mm"
                          // defaultValue={props.memoirData.start_date_mm}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'start_date_mm',
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="dd"
                          // defaultValue={props.memoirData.start_date_dd}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'start_date_dd',
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-8">
                    <label>End date</label>
                    <CustomDatePicker
                      id={"test"}
                      value={props.memoirData.start_date}
                      max={moment().toISOString().substring(0, 10)}
                      onChange={(e) =>
                        handleMemoirFieldChange("end_date", e.target.value)
                      }
                      isRequired={false}
                    />
                    {/* <input
											type='date'
											className='form-control'
											placeholder='yyyy'
											
											onChange={e =>
												handleMemoirFieldChange(
													'end_date',
													e.target.value
												)
											}
										/> */}
                    {/* <div className="row">
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="yyyy"
                          // defaultValue={props.memoirData.end_date_yyyy}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'end_date_yyyy',
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="mm"
                          // defaultValue={props.memoirData.end_date_mm}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'end_date_mm',
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="dd"
                          // defaultValue={props.memoirData.end_date_dd}
                          onChange={(e) =>
                            handleMemoirFieldChange(
                              'end_date_dd',
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                <Row>
                  <Col md="8">
                    <label className="d-flex mt-3">Add a Location</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="City"
                      // required={
                      // 	props.profileType == 'else'
                      // }
                      // defaultValue={props.memoirData.location}
                      onChange={(e) =>
                        handleMemoirFieldChange("location", e.target.value)
                      }
                    ></input>
                  </Col>
                </Row>
              </div>

              <h5 className="d-flex mt-5">Memoir Privacy Settings</h5>
              <div className="d-flex">
                <p className="mt-0">
                  Your privacy is extremely important to us. You can
                  <br />
                  change these settings at anytime
                </p>
              </div>
              <div className="settings">
                <div className="d-flex align-items-center">
                  <span>
                    <CustomToggler
                      // defaultValue={props.memoirData.isMemoirPublic}
                      value={props.memoirData.isMemoirPublic}
                      isDisabled={false}
                      onChange={async (e) => {
                        handleMemoirFieldChange(
                          "isMemoirPublic",
                          e.target.value
                        );
                        if (e.target.value == true) {
                          console.log("Inside");
                          await handleMemoirFieldChange(
                            "isIntroductionVisible",
                            false
                          );
                        }
                      }}
                    />
                  </span>
                  <p className="font-weight-bold ml-4">Memoir is public</p>
                </div>
                <div className="d-flex align-items-center">
                  <span>
                    <CustomToggler
                      // defaultValue={
                      // 	props.memoirData
                      // 		.isHomeTownPublic
                      // }
                      value={props.memoirData.isHomeTownPublic}
                      isDisabled={false}
                      onChange={(e) =>
                        handleMemoirFieldChange(
                          "isHomeTownPublic",
                          e.target.value
                        )
                      }
                    />
                  </span>
                  <p className="font-weight-bold ml-4">Hometown is public</p>
                </div>
                <div className="d-flex align-items-center">
                  <span>
                    <CustomToggler
                      // defaultValue={
                      // 	props.memoirData.isDOBPublic
                      // }
                      value={props.memoirData.isDOBPublic}
                      onChange={(e) =>
                        handleMemoirFieldChange("isDOBPublic", e.target.value)
                      }
                      isDisabled={false}
                    />
                  </span>
                  <p className="font-weight-bold ml-4">DOB is public</p>
                </div>
                {/* <div className="d-flex align-items-center">
                  <span>
                    <CustomToggler
                      defaultValue={props.memoirData.isHideFromSearchEngines}
                      onChange={(e) =>
                        handleMemoirFieldChange(
                          'isHideFromSearchEngines',
                          e.target.value
                        )
                      }
                    />
                  </span>
                  <p className="font-weight-bold ml-4">
                    Hide from search engines
                  </p>
                </div> */}

                <div className="d-flex align-items-center">
                  <span>
                    <CustomToggler
                      // defaultValue={props.memoirData.isIntroductionVisible}
                      onChange={(e) =>
                        handleMemoirFieldChange(
                          "isIntroductionVisible",
                          e.target.value
                        )
                      }
                      value={props.memoirData.isIntroductionVisible}
                      isDisabled={props.memoirData.isMemoirPublic}
                    />
                  </span>
                  <p className="font-weight-bold ml-4">
                    Allow memoir introduction to be visible
                  </p>
                </div>
              </div>
              <div className="d-flex mt-3 justify-content-center">
                <button
                  className="btn btn-outline w-100 mr-2 dashboard-btn"
                  style={{
                    border: "1.5px solid #D93D13",
                    color: "#D93D13",
                  }}
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : "Create a memoir"}
                </button>
                <button
                  className="btn btn-outline w-100 dashboard-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    props.toggleModal("createTimeline");
                    handleMemoirFieldChange("date_of_birth", "");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}

export default CreateMemora;
